// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3Lc4uzgqoERRK9-DSJomW5_0","card-box":"_1DY5FGZhhsJ1OqgIQLWpHG_0","active":"_35SeNjnKj0gFvL2KPjfp3E_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40b4531a","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.player/ui/game-states/LEGISLATING/chancellor-policies.vue
// module id = 205
// module chunks = 0